import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { baseQuery } from './base.query';

export const featureApi = createApi({
  reducerPath: 'featureApi',
  baseQuery: baseQuery,
  tagTypes: ['Feature'],
  endpoints: (builder) => ({
    getFeatureFlags: builder.query({
      query: () => ({ url: API_PREFIX.NEXTGEN + API.FEATURE_FLAGS }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetFeatureFlagsQuery } = featureApi;
